import { AlertConfig, AlertTypes, CrudTableViewConfig, CrudViewColumnType, DropdownMenuComponentConfig, DropdownMenuPlacement, HeadingComponentConfig, HeadingType, IconType, MenuActionBehavior, TextComponentConfig } from '@rappider/rappider-components/utils';

export const FILE_LIST_CONFIG: CrudTableViewConfig = {
  searchable: true,
  multipleSearchFields: ['name'],
  sortable: true,
  pageSize: 10,
  title: {
    content: 'All Objects',
    type: HeadingType.H4
  },
  showPagination: true,
  nzFrontPagination: true,
  selectable: true,
  enableMultipleSelection: true,
  columns:
    [
      {
        title: 'Model Name',
        type: CrudViewColumnType.Text,
        fieldName: 'name',
        visible: true
      }
    ],
  orderable: false,
  listActions: [],
  itemActions: []
};

export const fileListButton = {
  fileListButtonIcon: {
    type: 'FONT_AWESOME',
    name: 'fa-solid fa-cloud-arrow-up',
    color: '#ffffff',
    size: 'var(--margin-3x)',
    text: 'Save',
    customColorSettings: {
      backgroundColor: 'var(--primary-color)',
      color: '#ffffff'
    },
    borderSettings: {
      borderColor: 'var(--primary-color)'
    }
  }
};

export const SELECTED_FILE_LIST_CONFIG: CrudTableViewConfig = {
  searchable: false,
  filterable: false,
  multipleSearchFields: ['name'],
  sortable: true,
  title: {
    content: 'Selected Objects',
    type: HeadingType.H4
  },
  pageSize: 10,
  showPagination: false,
  nzFrontPagination: false,
  columns:
    [
      {
        title: 'Model Name',
        type: CrudViewColumnType.Text,
        fieldName: 'name',
        visible: true
      }
    ],
  orderable: false,
  listActions: [],
  itemActions: []
};

export const salesforceInfoAlertConfig = {
  type: AlertTypes.Info,
  title: <HeadingComponentConfig>{
    content: 'Frequency Selection',
    type: HeadingType.H6
  },
  description: <TextComponentConfig>{
    text: `Please choose a frequency to proceed. Note: Free users are limited to a single use.`
  },
  closeable: false,
  showIcon: true
};

export const errorAlertConfig: AlertConfig = {
  type: AlertTypes.Error,
  title: {
    content: 'An error occurred',
    type: HeadingType.H5
  },
  description: {
    text: ''
  },
  showIcon: true,
  closeable: false
};

export const frequencyConfig = [
  {
    key: '12 Hour',
    value: '0 */12 * * *'
  },
  {
    key: '24 Hour',
    value: '0 0 * * *'
  }
];
